/**
 * 证件检测统一阈值。
 *
 * 坐标、尺寸和位移都使用 0~1 的归一化比例，角度使用 degree，时间使用 ms。
 * 检测分成两档：
 * 1. 基础阈值（minWidthRatio、positionTolerance 等）决定证件是否真正合格，
 *    只有这一档连续稳定后才允许拍照；
 * 2. recording*Tolerance 是仅供预录制使用的额外容错，目的是让录像提前开始，
 *    避免用户已经摆正证件后还要再等待 3 秒。它不会放宽最终拍照标准。
 */
export const DOCUMENT_CONFIG = Object.freeze({
  // 最终拍照要求：证件宽高应占目标框的 80%~105%。
  minWidthRatio: 0.8,
  maxWidthRatio: 1.05,
  minHeightRatio: 0.8,
  maxHeightRatio: 1.05,
  // 最终拍照要求：旋转不超过 7°，透视形变不超过 0.24。
  maxAngle: 7,
  maxPerspectiveSkew: 0.24,
  // 预录制容错：有效区间为尺寸 74%~111%、位置 7.5%、角度 9°、透视 0.27。
  recordingSizeTolerance: 0.06,
  recordingPositionTolerance: 0.02,
  recordingAngleTolerance: 2,
  recordingPerspectiveTolerance: 0.03,
  // 最终合格状态需连续保持 500ms；短暂丢失最多沿用 4 帧历史四角。
  stableDuration: 500,
  maxMissedFrames: 4,
  // 四角 EMA 平滑权重：越大越跟手，越小越稳定；0.38 偏向减少视觉抖动。
  emaAlpha: 0.38,
  maxStableMovement: 0.018,
  minConfidence: 0.28,
  minDocumentAspectRatio: 1.15,
  maxDocumentAspectRatio: 2.1,
  completeMargin: 0.012,
  positionTolerance: 0.055,
  targetMaxWidth: 0.86,
  targetMaxHeight: 0.72,
  documentAspectRatio: 1.586,
  detectorSampleWidth: 320,
  desktopDetectorFps: 20,
  mobileDetectorFps: 12,
  initializationTimeout: 15000,
  detectionTimeout: 3000,
});

// 移动端降低检测频率以控制发热和耗电；返回相邻检测请求的最小时间间隔。
export const getDetectorInterval = (isMobile) =>
  Math.round(
    1000 /
      (isMobile
        ? DOCUMENT_CONFIG.mobileDetectorFps
        : DOCUMENT_CONFIG.desktopDetectorFps),
  );
